module.exports = __webpack_public_path__ + "static/media/alpha-logo.bc0a7f7d.webp";